import useMenuDrawer from './hooks/useMenuDrawer'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuIcon from '@mui/icons-material/Menu'
import MailIcon from '@mui/icons-material/Mail'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import Drawer from '../control/Drawer'
import withDialog, { CallBackOpenDialog } from '../control/dialogAlert/withDialog'

type MenuDrawerPlaygroundType = ReturnType<typeof useMenuDrawer>

let MenuDrawerPlaygroundView = (props: MenuDrawerPlaygroundType) => {
    const {
        menu,
        onClickMenu_1,
        onOpen_1,
        onClose_1,
        onClickDim_1,
        openDrawer_1,
        onClickMenu_2,
        onOpen_2,
        onClose_2,
        onClickDim_2,
        openDrawer_2
    } = props

    return (
        <div>
            <Grid container>
                <Typography variant="h3" gutterBottom>
                    Control: Menu Drawer
                </Typography>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1">Drawer with data list</Typography>
                </Grid>
                <Grid item xs={12}>
                    <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={onOpen_1}>
                        <MenuIcon />
                    </IconButton>
                    <Drawer
                        dataSource={menu}
                        position={'left'}
                        onClickMenu={onClickMenu_1}
                        isOpen={openDrawer_1}
                        onClose={onClose_1}
                        onClickBackdrop={onClickDim_1}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} style={{ paddingTop: 40 }}>
                <Grid item xs={12}>
                    <Typography variant="body1">Drawer with component</Typography>
                </Grid>
                <Grid item xs={12}>
                    <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={onOpen_2}>
                        <MenuIcon />
                    </IconButton>
                    <Drawer position={'left'} isOpen={openDrawer_2} onClose={onClose_2} onClickBackdrop={onClickDim_2}>
                        <div style={{ width: 250 }}>
                            <List>
                                {menu?.map((item: any, index: number) => (
                                    <ListItem
                                        button
                                        key={index}
                                        onClick={() => {
                                            onClickMenu_2(item)
                                        }}
                                    >
                                        <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                                        <ListItemText primary={item.name} />
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    </Drawer>
                </Grid>
            </Grid>
        </div>
    )
}

//Controller
type MenuDrawerPlaygroundProps = CallBackOpenDialog
let MenuDrawerPlayground = (props: MenuDrawerPlaygroundProps) => {
    const { openDialog } = props
    const menuDrawerModel = useMenuDrawer({ openDialog })
    return <MenuDrawerPlaygroundView {...menuDrawerModel} />
}

MenuDrawerPlayground = withDialog(MenuDrawerPlayground)
export default MenuDrawerPlayground

const useStyles = makeStyles((theme: Theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    gridBtn: {
        marginTop: '2%',
    },
}))
